import { Mobile } from '@bimser/common';
import { BCEditor, BCEditorRef, EditorToolbarType } from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import React, { JSX } from 'react';
import MultiLanguageTextControl from '../../base/MultiLanguageTextControl';
import Styles from './assets/style.scss';
import { IHTMLTextBoxProperties } from './entities/IHTMLTextBoxProperties';

export default class HTMLTextBox extends MultiLanguageTextControl {
	height: number;
	toolbarBottom: boolean;
	toolbarType: EditorToolbarType;
	charCounterMax: number;
	inputRef = React.createRef<BCEditorRef>();

	constructor() {
		super();
		this.onValueChanged = this.onValueChanged.bind(this);
		this._lastTextAlign = this._lastTextAlign.bind(this);

		this.controlType = FormItemTypes.EControlTypes.HTMLTextBox;

		this.height = null;
		this.toolbarBottom = false;
		this.toolbarType = 'basic';

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.onValueChanged('system', value);
		});
		this.subscribe('trigger:OnLanguageValueChanged', (data: any) => {
			const mlData = JSON.parse(data);

			Object.keys(mlData).forEach(culture => {
				this.multiLanguageText.setText(mlData[culture], culture);
			});
		});
	}

	__loadProperties(data: IHTMLTextBoxProperties) {
		super.__loadProperties(data);
		this.height = data.height;
		this.toolbarBottom = data.toolbarBottom;
		this.toolbarType = data.toolbarType;
		this.charCounterMax = data.charCounterMax;
		this.showCharacterCounter = data.showCharacterCounter;
	}

	private _lastTextAlign(textAlign) {
		switch (textAlign) {
			case 'left':
				return 'left';
			case 'right':
				return 'right';
			case 'center':
				return 'center';
			default:
				return 'left';
		}
	}

	protected onValueChanged(culture: string, text: string) {
		this.multiLanguageText.setText(text, culture);
		this.__proxyChanging.value = text;
	}

	__loadTextProperty() {}

	__loadValueProperty() {}

	focus() {
		this.inputRef.current?.focus();
	}

	__onBeforePrint(): boolean {
		this.inputRef.current?.setPrinting(true);

		return true;
	}

	__onAfterPrint(): void {
		this.inputRef.current?.setPrinting(false);
	}

	handleLinkClick(link: HTMLAnchorElement) {
		Mobile.MobileView.onHTMLTextBoxLinkClick(link.href);
	}

	__onFormScrollStart() {
		super.__onFormScrollStart();

		this.inputRef.current?.editor?.popups?.hide('link.edit');
	}

	__pureRender() {
		return (
			<BCEditor
				ref={this.inputRef}
				enableMultilanguage={this.enableMultiLanguageText}
				value={this.multiLanguageText.getData()}
				readOnly={this.__isDisabled() || this.__isReadOnly()}
				toolbarType={this.toolbarType}
				toolbarBottom={this.toolbarBottom}
				height={this.height}
				placeHolder={this.placeholder.getText()}
				style={this.style}
				className={Styles.EditorWrapper}
				toolbarSticky={false}
				noFullscreen={this.__form.displayMode == 'preview'}
				charCounterMax={this.charCounterMax}
				charCounterCount={this.showCharacterCounter}
				onLinkClick={this.handleLinkClick}
				iframe={this.__form.getShadowDomMode()}
				onValueChange={this.onValueChanged}
				//scrollableContainer={`#${this.name}`} https://github.com/froala/react-froala-wysiwyg/issues/402
			/>
		);
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			height: this.height,
			toolbarBottom: this.toolbarBottom,
			toolbarType: this.toolbarType,
			charCounterMax: this.charCounterMax,
			showCharacterCounter: this.showCharacterCounter
		};
	}

	__render(children?: JSX.Element) {
		return super.__render(this.__pureRender());
	}
}
